export const MyScreenersDesktop = () => {
  // TODO: Add desktop content
  return null;
};

export const MyScreenersMobile = () => {
  // TODO: Add mobile content
  return null;
};
